<template>
    <content-layout>
        <h1 slot="header">Mans profils</h1>

        <div class="file-filter-container">
            <div class="row">
                <div class="small-6 medium-4 large-2 column" style="display: flex; align-items: center;">
                    <p class="tag">Mani materiāli</p>
                </div>
                <div class="small-6 medium-8 large-10 column">
                    <my-material-filter :current.sync="sort"></my-material-filter>
                </div>
            </div>
        </div>

        <div>
            <div class="row my-profile">
                <div class="small-6 medium-4 large-2 column sidebar">
                    <my-profile-info></my-profile-info>
                </div>
                <div class="small-6 medium-8 large-10 column content">

                    <div>
                        <!--<h4>Manu materiālu sadalījums</h4>-->
                        <div class="row small-up-1 medium-up-2 large-up-4">
                            <spinner v-if="loadingCategories === true" class="spinner"></spinner>
                            <div v-else class="column" v-for="node in myCategories" :key="node.id">
                                <category-title-item :title="node.category.title"
                                                     :children-count="node.category.user_materials_count"
                                                     :link-to="{ name: 'profile.categories', params: { categoryNodeId: node.id} }"></category-title-item>
                            </div>
                        </div>
                    </div>

                    <hr/>

                    <div class="file-list-container row small-up-1 medium-up-2 large-up-4">
                        <spinner v-if="loading === true" class="spinner"></spinner>
                        <template v-else="">
                            <div class="column" v-for="material in materials" :key="material.id">
                                <my-material-item :material="material"></my-material-item>
                            </div>
                        </template>
                    </div>

                    <div class="pagination-container">
                        <pagination :current.sync="page" :total="pages"></pagination>
                    </div>

                </div>
            </div>
        </div>
    </content-layout>
</template>

<script>
    import ContentLayout from '../layouts/ContentLayout'
    import MyMaterialItem from '../components/MyMaterialItem'
    import MyMaterialFilter from '../components/MyMaterialFilter'
    import Pagination from '../components/common/Pagination'
    import CategoryTitleItem from '../components/CategoryTitleItem'
    import MyProfileInfo from '../components/profile/MyProfileInfo'
    import { mapGetters } from 'vuex'

    import materials from '../api/materials'
    import categories from '../api/categories'
    import user from '../api/user';
    import CategoryItem from '../components/CategoryItem';


    export default {

        created() {
            if (this.user) {
                this.getMaterials();
                this.getCategoriesWithCount();
            }
        },

        data() {
            return {
                sort: 'created_at',
                page: 1,
                materials: [],
                pages: 1,
                myCategories: [],
                loading: false,
                loadingCategories: false
            }
        },

        computed: {
            ...mapGetters(['user']),
        },

        methods: {
            /**
             * Get User materials or bookmarks.
             */
            getMaterials() {
                this.loading = true;
                switch (this.sort) {
                    // Special handling of bookmarks tab
                    case 'bookmarks':
                        user.bookmarks()
                            .then(response => {
                                console.log('get bookmarks', response.data);
                                this.setMaterial(response.data);
                                this.loading = false;
                            });
                        break;

                    default:
                        materials.get({ sort: this.sort, page: this.page, owner: this.user.id })
                            .then(response => {
                                console.log('get materials', response.data);
                                this.setMaterial(response.data);
                                this.loading = false;
                            })
                }
            },

            /**
             * Set materials from API response data
             *
             * @param {Array} data
             * @param {Object} meta
             */
            setMaterial({ data, meta }) {
                this.materials = data;
                this.pages = meta ? meta.last_page : 1;
                this.page = meta ? meta.current_page : 1;
            },

            getCategoriesWithCount() {
                this.loadingCategories = true;
                categories.get({ depth: 0, with_user_item_count: this.user.id })
                    .then(response => {
                        this.myCategories = response.data;
                        this.loadingCategories = false;
                })
            },

            /**
             * Reset component data
             */
            reset() {
                Object.assign(this.$data, this.$options.data.apply(this))
            }
        },

        watch: {
            /**
             * Reload user profile when user changes or signs out.
             *
             * @param val
             * @param oldVal
             */
            user: function (val, oldVal) {
                console.log('user changed', val, oldVal);
                if (!val) {
                    this.reset();
                } else if (oldVal === null || val.id !== oldVal.id || this.materials.length === 0) {
                    this.getMaterials();
                    this.getCategoriesWithCount();
                }
            },

            /**
             *
             * @param val
             * @param oldVal
             */
            sort: function (val, oldVal) {
                console.log('sort changed', val, oldVal);
                if (typeof val !== 'undefined' && val !== null  && val !== oldVal) {

                    //Reset page when switching to bookmarks
                    if (val === 'bookmarks') {
                        this.page = 1;
                    }

                    this.getMaterials();
                }
            },

            /**
             *
             * @param val
             * @param oldVal
             */
            page: function (val, oldVal) {
                console.log('page changed', val, oldVal);
                if (typeof val !== 'undefined' && val !== null  && val !== oldVal) {
                    this.getMaterials();
                }
            }
        },

        components: {
            MyProfileInfo, CategoryItem, CategoryTitleItem, MyMaterialItem, MyMaterialFilter, ContentLayout, Pagination }
    }
</script>

<style lang="scss" scoped>
    @import "../../sass/settings";
    @import "../../sass/mixins";
    @import "../../sass/foundation/config";

    .file-filter-container {
        background-color: white;
    }

    .sidebar,
    .content {
        padding-top:  2rem;
    }

    .tag {
        color: white;
        font-size: 14px;
        font-weight: 700;
        background-color: #7b7979;
        position: relative;
        height: 30px;
        line-height: 30px;
        margin: 0;
        padding: 0 1em;
        display: inline-block;
        white-space: nowrap;

        &:after {
            content: "";
            position: absolute;
            right: -30px;
            border: 15px solid transparent;
            border-left-color: #7b7979;
        }
    }

    //TODO duplicate
    .file-list-container {
        padding-bottom: 1.875rem;
    }

    //TODO duplicate
    .pagination-container {
        text-align: center;
    }
</style>


// WEBPACK FOOTER //
// resources/assets/js/views/MyProfile.vue